module.exports = __webpack_public_path__ + "assets/f333992a8c62523f2bf804764ee3bc42.mp3";